import { NAVIGATION } from '../constants/universal_header.js';
import { canView } from './permissions.js';
import { VIAFOURA_ROOT_UUID } from 'commons/constants/parse.js';
import { translateUuidToId } from '@/util/filters.js';
import { getCookie } from '@/store/modules/sites/actions.js';

const hasPermissionsWrap = (fn, name, user) => (...args) => {
    if (canView(name, user)) {
        return fn(...args);
    }
    return false;
};

export const analytics = ({ baseAdminLink }, user) => hasPermissionsWrap(() => `${baseAdminLink}/analytics/insights`, NAVIGATION.ANALYTICS, user)();

export const consoleLink = ({ baseConsoleLink }, user) => hasPermissionsWrap(() => `${baseConsoleLink}/moderation`, NAVIGATION.CONSOLE, user)();

export const portalLink = ({ basePortalLink }, user) => hasPermissionsWrap(() => {
    const uuid = getCookie('loginSessionUuid') || VIAFOURA_ROOT_UUID;
    return `${basePortalLink}/admin/${translateUuidToId(uuid)}/settings/general`;
}, NAVIGATION.PORTAL, user)();

export const clients = ({ baseAdminLink }, user) => hasPermissionsWrap(() => `${baseAdminLink}/client`, NAVIGATION.CLIENTS, user)();

export const onSite = ({ baseAdminLink }) => `${baseAdminLink}/moderators`;

export const users = ({ baseAdminLink }) => `${baseAdminLink}/user/users`;

export const userProfile = ({ baseAdminLink }, user) => `${baseAdminLink}/user/${user.id}`;

export const changePassword = ({ baseAdminLink }) => `${baseAdminLink}/login/change_password`;

export const switchSites = ({ baseAdminLink }, user) => hasPermissionsWrap(
    () => `${baseAdminLink}/site_picker/index/${encodeURIComponent('/moderators')}`, NAVIGATION.SWITCH_SITES, user,
)();

export const siteSettings = ({ baseAdminLink }, user) => hasPermissionsWrap(() => `${baseAdminLink}/settings/module/general`, NAVIGATION.SITE_SETTINGS, user)();

export const logout = ({ baseAdminLink }) => `${baseAdminLink}/login/logout`;
